import { render, staticRenderFns } from "./CorporateBase.vue?vue&type=template&id=d1ba1624&"
import script from "./CorporateBase.vue?vue&type=script&lang=js&"
export * from "./CorporateBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports